import { IDataDisplayer } from "components/IDataDisplayer/DataDisplayer";
import createGridElements from "components/WarehouseElements/Grid/GridElement/GridElementFactory";
import WarehouseGrid from "components/WarehouseElements/Grid/WarehouseGrid/WarehouseGrid";
import createShortcuts from "components/WarehouseElements/WarehouseHeaders/WarehouseSearchZone/Shortcuts/ShortcutsFactory";
import { WarehouseInfos } from "models/PlanInfos";
import { JSX } from "react";
import { getWarehousePlan } from "store/Selectors/warehousePlanSelector";
import {
  setGridCheckpoints,
  setGridHeight,
  setGridWidth,
} from "store/Slices/gridLayoutSlice";
import { setWarehousePlan } from "store/Slices/warehousePlanSlice";
import { store } from "store/store";

let gridElementsComponents: JSX.Element[] = [];
let shortcuts: JSX.Element[] = [];
let storeNb: number | undefined;

function WarehouseGridDisplayer({
  elements,
  shortcuts,
  storeNb,
}: {
  elements: JSX.Element[];
  shortcuts: JSX.Element[];
  storeNb?: number;
}) {
  return (
    <WarehouseGrid
      gridElements={elements}
      shortcuts={shortcuts}
      storeNb={storeNb}
    />
  );
}

export const WarehouseGridAdapter: IDataDisplayer = {
  initialisePlan() {
    const warehouseInfos = getWarehousePlan(store.getState());
    const planData = warehouseInfos.plan;
    const planDimensions = planData?.dimensions;
    const planCheckpoints = planData?.shortcuts;

    if (!planData || !planDimensions) return;

    store.dispatch(
      setGridWidth(planDimensions.end.x - planDimensions.start.x + 1)
    );
    store.dispatch(
      setGridHeight(planDimensions.end.y - planDimensions.start.y + 1)
    );

    if (planCheckpoints) {
      store.dispatch(setGridCheckpoints(planCheckpoints));
    }

    this.updateWarehousePlan(warehouseInfos);
  },

  updateWarehousePlan(plan: WarehouseInfos): void {
    if (plan.plan) {
      gridElementsComponents = createGridElements(plan.plan.elements);
      shortcuts = createShortcuts(plan.plan.shortcuts);
      storeNb = plan.storeNb;
    }
    store.dispatch(setWarehousePlan(plan));
  },

  renderDisplayer(): JSX.Element {
    return (
      <WarehouseGridDisplayer
        elements={gridElementsComponents}
        shortcuts={shortcuts}
        storeNb={storeNb}
      />
    );
  },
};
